import { init as initSentry, replayIntegration } from '@sentry/react';
import { reactRouterBrowserTracingIntegration } from '@sentry/react/react-router';

import { env } from '~/constants/env';

initSentry({
  dsn: env.IS_PRODUCTION_ENV || env.IS_STAGING_ENV ? env.SENTRY_DSN : '',
  environment: env.VERCEL_ENVIRONMENT,
  normalizeDepth: 10,
  integrations: [
    replayIntegration({ maskAllText: false, networkDetailAllowUrls: [env.API_URL] }),
    reactRouterBrowserTracingIntegration({
      shouldCreateSpanForRequest: (url) => !/\/ping\/?$/.test(url),
      consistentTraceSampling: true,
    }),
  ],
  ignoreErrors: [/HTTP error (401|429|503)/, /Failed to fetch/, /Load failed/, /NetworkError when attempting to fetch resource/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  tracesSampleRate: 0.1,
  tracePropagationTargets: [env.API_URL],
});
